import * as React from 'react';
import * as _ from "lodash";
import { Button, Grid, Dropdown, Form, Icon, Label } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import { allowedOperators } from 'data/trident-campaigns';

interface SubCountConditionProps {
  onChange: Function,
  onDelete: Function,
  options: object[],
  lhs: string[],
  operator: string,
  rhs: number,
}

@formComponent()
export default class SubCountCondition extends React.Component<SubCountConditionProps> {
  render() {
    const spanStyle = {
      color: 'green',
      fontWeight: 700,
    };
    const deleteButtonStyle = {
      cursor: 'pointer',
      marginTop: '10px',
    };
    const gridStyle = {
      marginLeft: 40,
    };

    return (
      <React.Fragment>
        <Grid>
          <Grid.Column width={16}>
            <Icon name="circle" color="grey" />
            <span style={spanStyle}>Sum of</span>
          </Grid.Column>
        </Grid>

        <Grid>
          <Grid.Column width={4}>
            <Dropdown
              placeholder="Count Targets"
              selection
              multiple
              options={this.props.options}
              value={this.props.lhs}
              name="lhs"
              onChange={(_,data) => this.props.onChange(data)}
            />
          </Grid.Column>
          <Grid.Column width={4} textAlign="left">
            <FormInputWithError
              name="operator"
              {...this.props}
            >
              <Form.Select
                name="operator"
                options={allowedOperators}
                value={this.props.operator}
                onChange={(_,data) => this.props.onChange(data)}
              />
            </FormInputWithError>
          </Grid.Column>
          <Grid.Column width={4} style={gridStyle}>
            <FormInputWithError
              name="rhs"
              {...this.props}
            >
              <Form.Input
                name="rhs"
                type="number"
                required
                value={this.props.rhs}
                onChange={(_,data) => this.props.onChange(data)}
              />
            </FormInputWithError>
          </Grid.Column>
          <Grid.Column width={2} style={gridStyle} textAlign="right">
            <Label
              size="small"
              color="violet"
              style={deleteButtonStyle}
              onClick={this.props.onDelete}
            >
              <Icon name="trash alternate" /> Delete
            </Label>
          </Grid.Column>
        </Grid>
      </React.Fragment>
    )
  }
}
